import { useMemo } from "react";
import { formatRut } from "../helpers/app";
import { UserProps } from "../interfaces";

export const optionsIngressType = [
    {
        label: "dependiente",
        value: "dependent"
    },
    {
        label: "independente",
        value: "independent"
    },
];

export const optionsContractType = [
    {
        label: "plazo fijo",
        value: "fixed_term"
    },
    {
        label: "indefinido",
        value: "indefinite"
    },
];

export const optionsAntiquity = [
    {
        label: {
            value: "0-6",
            time: "meses"
        },
        value: 0
    },
    {
        label: {
            value: "6-12",
            time: "meses"
        },
        value: 1
    },
    {
        label: {
            value: "1-2",
            time: "años"
        },
        value: 2
    },
    {
        label: {
            value: "+2",
            time: "años"
        },
        value: 3
    },
];

export const useDisabledSaveBankData = (bankData: any) => {
    const isDisabled: any = useMemo(() => {
        let disabled = false;
        if(
            !bankData?.bank?.bankName?.value.length 
            || !bankData?.bank?.accountType?.value.length 
            || !bankData?.bank?.accountNumber?.value.length
        ){
            disabled = true;
        }
		return disabled;
    }, [bankData]);
    return isDisabled;
}

export const useDisabledSaveSigners = (firstSigner: any, secondSigner: any) => {
    const isDisabled: any = useMemo(() => {
        let disabled = false;
        if(
            !firstSigner?.name?.value.length 
            || !firstSigner?.lastName?.value.length 
            || !firstSigner?.rut?.value.length 
            || !firstSigner?.region?.value?.name.length 
            || !firstSigner?.city?.value?.name.length 
            || !firstSigner?.commune?.value?.name.length 
        ){
            disabled = true;
        }
		return disabled;
    }, [firstSigner, secondSigner]);
    return isDisabled;
}

export const ValidateBankData = (
    setBankData: Function,
    bankData: any, 
) => {
    let someErrorBankData: boolean = false;
    let errorBankData = {
        bankName: "",
        accountType: "",
        accountNumber: ""
    };

    if(!bankData?.bank?.bankName?.value) errorBankData.bankName = "Debes seleccionar un banco";
    if(!bankData?.bank?.accountType?.value) errorBankData.accountType = "Debes seleccionar un tipo de cuenta";
    if(!bankData?.bank?.accountNumber?.value) errorBankData.accountNumber = "Debes ingresar un numero de cuenta";

    setBankData({
        ...bankData, 
        bank: {
            ...bankData?.bank,
            bankName: {
                ...bankData?.bank?.bankName,
                error: errorBankData.bankName
            },
            accountType: {
                ...bankData?.bank?.accountType,
                error: errorBankData.accountType
            },
            accountNumber: {
                ...bankData?.bank?.accountNumber,
                error: errorBankData.accountNumber
            }
        }
    });

    someErrorBankData = Object.values(someErrorBankData).some((value: any) => value.length > 0);

    return !someErrorBankData;
}

export const ValidateSigners = (
    setFirstSigner: Function,
    firstSigner: any, 
    setSecondSigner: Function,
    secondSigner: any
) => {
    let someErrorFirstSigner: boolean = false;
    let someErrorSecondSigner: boolean = false;
    let errorFirstSigner = {
        name: "",
        lastName: "",
        rut: "",
        region: "",
        city: "",
        commune: ""
    };
    let errorSecondSigner = {
        name: "",
        lastName: "",
        rut: "",
        region: "",
        city: "",
        commune: ""
    };
    
    if(!firstSigner?.name?.value) errorFirstSigner.name = "Debes ingresar un nombre";
    if(!firstSigner?.lastName?.value) errorFirstSigner.lastName = "Debes ingresar un apellido";
    if(!firstSigner?.rut?.value) errorFirstSigner.rut = "Debes ingresar un RUT";
    if(!firstSigner?.region?.value?.id) errorFirstSigner.region = "Debes seleccionar una región";
    if(!firstSigner?.city?.value?.id) errorFirstSigner.city = "Debes seleccionar una ciudad";
    if(!firstSigner?.commune?.value?.id) errorFirstSigner.commune = "Debes seleccionar una comuna";

    setFirstSigner({
        ...firstSigner, 
        name: {
            ...firstSigner?.name, 
            error: errorFirstSigner.name
        },
        lastName: {
            ...firstSigner?.lastName, 
            error: errorFirstSigner.lastName
        },
        rut: {
            ...firstSigner?.rut,
            error: errorFirstSigner.rut
        },
        region: {
            ...firstSigner?.region,
            error: errorFirstSigner.region
        },
        city: {
            ...firstSigner?.city,
            error: errorFirstSigner.city
        },
        commune: {
            ...firstSigner?.commune,
            error: errorFirstSigner.commune
        }
    });

    // Si no hay nada cargado del segundo firmante:
    if(!secondSigner?.name?.value && !secondSigner?.lastName?.value && !secondSigner?.rut?.value && !secondSigner?.region?.value?.id && !secondSigner?.city?.value?.id && !secondSigner?.commune?.value?.id){
        return {valid: true, secondSigner: "empty"};
    }

    if(!secondSigner?.name?.value) errorSecondSigner.name = "Debes ingresar un nombre";
    if(!secondSigner?.lastName?.value) errorSecondSigner.lastName = "Debes ingresar un apellido";
    if(!secondSigner?.rut?.value) errorSecondSigner.rut = "Debes ingresar un RUT";
    if(!secondSigner?.region?.value?.id) errorSecondSigner.region = "Debes seleccionar una región";
    if(!secondSigner?.city?.value?.id) errorSecondSigner.city = "Debes seleccionar una ciudad";
    if(!secondSigner?.commune?.value?.id) errorSecondSigner.commune = "Debes seleccionar una comuna";

    someErrorFirstSigner = Object.values(errorFirstSigner).some((value: any) => value.length > 0);
    someErrorSecondSigner = Object.values(errorSecondSigner).some((value: any) => value.length > 0);

    setSecondSigner({
        ...secondSigner, 
        name: {
            ...secondSigner?.name, 
            error: errorSecondSigner.name
        },
        lastName: {
            ...secondSigner?.lastName, 
            error: errorSecondSigner.lastName
        },
        rut: {
            ...secondSigner?.rut,
            error: errorSecondSigner.rut
        },
        region: {
            ...secondSigner?.region,
            error: errorSecondSigner.region
        },
        city: {
            ...secondSigner?.city,
            error: errorSecondSigner.city
        },
        commune: {
            ...secondSigner?.commune,
            error: errorSecondSigner.commune
        }
    });

    return {valid: !(someErrorFirstSigner || someErrorSecondSigner), secondSigner: ""};
}

export const UploadBankData = (
    user: UserProps | null,
    bankData: any, 
    patchBankData: Function,
) => {
    patchBankData(
        user?.branch, 
        {
            bank: bankData?.bank?.bankName?.value,
            account_type: bankData?.bank?.accountType?.value,
            account_number: bankData?.bank?.accountNumber?.value
        }
    );
}

export const UploadSigners = (
    signers: any,
    firstSigner: any, 
    secondSigner: any,
    postSigners: Function,
    putSigners: Function,
    emptySecond: boolean
) => {
    const defaultFirstSignerData = {
        "email": "signer1@denwaip.com",
        "country": "Chile",
        "phone": {
            "code": "+56",
            "number": "123123",
            "country_code_text": "CL"
        },
    };
    
    const firstSignerData = {
        "name": firstSigner?.name?.value,
        "last_name": firstSigner?.lastName?.value,
        "legal_id": formatRut(firstSigner?.rut?.value),
        "residence": {
            "region_id": firstSigner?.region?.value?.id,
            "region_name": firstSigner?.region?.value?.name,
            "city_id": firstSigner?.city?.value?.id,
            "city_name": firstSigner?.city?.value?.name,
            "commune_id": firstSigner?.commune?.value?.id,
            "commune_name": firstSigner?.commune?.value?.name
        },
        "order": 0
    }

    const defaultSecondSignerData = {
        "email": "signer2@denwaip.com",
        "country": "Chile",
        "phone": {
            "code": "+56",
            "number": "123123",
            "country_code_text": "CL"
        },
    };
    
    const secondSignerData = {
        "name": secondSigner?.name?.value,
        "last_name": secondSigner?.lastName?.value,
        "legal_id": formatRut(secondSigner?.rut?.value),
        "residence": {
            "region_id": secondSigner?.region?.value?.id,
            "region_name": secondSigner?.region?.value?.name,
            "city_id": secondSigner?.city?.value?.id,
            "city_name": secondSigner?.city?.value?.name,
            "commune_id": secondSigner?.commune?.value?.id,
            "commune_name": secondSigner?.commune?.value?.name
        },
        "order": 1
    }

    if(emptySecond){
        if(signers?.data.length === 0){
            postSigners({...defaultFirstSignerData, ...firstSignerData});
        }else{
            putSigners(firstSigner?.id, firstSignerData);
        }
        return;
    }

    if(signers?.data.length === 0){
        postSigners({...defaultFirstSignerData, ...firstSignerData});
        postSigners({...defaultSecondSignerData, ...secondSignerData});
    }

    if(signers?.data.length === 1){
        putSigners(firstSigner?.id, firstSignerData);
        postSigners({...defaultSecondSignerData, ...secondSignerData});
    }

    if(signers?.data.length === 2){
        putSigners(firstSigner?.id, firstSignerData);
        putSigners(secondSigner?.id, secondSignerData);
    }
}